import { cloneDeep } from 'lodash'
import TenantService from '../../services/TenantService';


export function fetchLocations ({ getters, commit }) {
  return new Promise((resolve, reject) => {

    TenantService.findAllLocations()
      .then(response => {
        commit('setAllLocations', response.data)
        resolve()
      }).catch(e => {
        commit('setAllLocations', null)
        reject(e)
      })
  })
}

export async function calcApproximateUserLocation ({ getters, commit }) {
  const position = await fetchCurrentUserLocation()

  return new Promise((resolve, reject) => {

    try {
      const localtions = cloneDeep(getters.allLocations)

      if (!position)
        return reject("'currentUserLocation' must be provided !")

      if (!getters.allLocations)
        return reject("'allLocations' must be provided !")


      localtions.forEach((location) => {
        location['distance_from_user'] = distance(position.latitude, position.longitude,
          location.latitude, location.longitude)
      })

      const nearest = sortNearestUserLocation(localtions)[0]
      delete nearest.distance_from_user

      commit('setLocation', nearest.sigla)
      resolve()
    } catch (error) {
      console.error(error);
      reject(error)
    }

  })
}


function fetchCurrentUserLocation () {
  return new Promise((resolve, reject) => {

    navigator.geolocation.getCurrentPosition(
      position => {
        resolve({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
        })
      },
      error => {
        console.error(error.message);
        reject(error.message)
      },
    )
  })
}

function distance (lat1, lon1, lat2, lon2) {
  var p = 0.017453292519943295;
  var c = Math.cos;
  var a = 0.5 - c((lat2 - lat1) * p) / 2 +
    c(lat1 * p) * c(lat2 * p) *
    (1 - c((lon2 - lon1) * p)) / 2;

  return 12742 * Math.asin(Math.sqrt(a));
}

function sortNearestUserLocation (obj) {
  return obj.sort((a, b) => (a.distance_from_user > b.distance_from_user) ? 1 : -1)
}
